<template>
  <div class="page-content" data-test-key="email-subscription-page">

    <SeoMeta 
        title="TheJobTap.com - Get Notified" 
        description="At TheJobTap, we believe you should be the first to know about job openings that match your skills and interests."
    />
    
<section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
        <div class="container mx-auto">
            <div class="grid">
                <div class="col-span-12">
                    <div class="text-center text-white">
                        <h1 class="mb-4 text-[26px]">Get Notified</h1>
                        <div class="page-next">
                          <p>Get job alerts for the latest roles in emerging tech. No account required. No noise.
                          </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
        <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
      </section>
    <section class="py-16">
        <div class="container mx-auto">
          
<div class="grid grid-cols-1">
  <div class="relative">
    <h5 class="mb-4 text-gray-900 dark:text-gray-50">Be the first to know about new AI, Web3 &amp; blockchain jobs</h5>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">Get instant alerts when new AI, Web3, and blockchain jobs are added to TheJobTap.com, so you can discover opportunities early and apply faster.</p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">From <strong>AI engineering, machine learning, and data</strong> to <strong>Web3 development, smart contracts, product, design, and growth roles</strong>, stay updated with openings that match your skills and interests.</p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><i>Less noise. Better timing. More relevant opportunities.</i></p>
    <button class="mt-4 mb-2 text-white border-transparent group-data-[theme-color=violet]:bg-violet-500 btn hover:-translate-y-2" style="background-color: rgba(0, 153, 255, 0.7) !important;">
      <a href="/" class="">Search Jobs <i class="align-middle uil uil-rocket ms-1"></i></a>
    </button>
  </div>

  <div class="relative mt-8">
    <h5 class="mb-4 text-gray-900 dark:text-gray-50">Why subscribe?</h5>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>Stay ahead in fast-moving tech markets.</strong></p>
    <ul class="pb-2 mb-4 space-y-4 text-gray-500 about-list dark:text-gray-300 mt-6">
      <li class="ltr:pl-7 rtl:pr-7"><strong>Instant job alerts</strong> sent straight to your inbox</li>
      <li class="ltr:pl-7 rtl:pr-7"><strong>Apply earlier</strong> to fresh roles before they get crowded</li>
      <li class="ltr:pl-7 rtl:pr-7"><strong>Relevant opportunities</strong> across engineering, data, design, product, and more</li>
      <li class="ltr:pl-7 rtl:pr-7"><strong>Free to join</strong> with no account required</li>
    </ul>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">Whether you are targeting AI roles, blockchain jobs, Web3 startups, or niche emerging tech opportunities, job alerts help you move faster when the right role goes live.</p>
  </div>

  <div class="relative mt-8">
    <h5 class="mb-4 text-gray-900 dark:text-gray-50">What makes TheJobTap.com different?</h5>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>Focused on emerging tech</strong></p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">TheJobTap.com is built for people looking for opportunities in AI, Web3, blockchain, and other high-growth technology sectors.</p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>Relevant jobs, not endless scrolling</strong></p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">We help you discover high-quality roles without wasting time on generic listings that do not match your goals.</p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>Coverage across the market</strong></p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">Explore opportunities from established tech companies, innovative startups, and specialist employers hiring across AI and Web3.</p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>Built for serious job seekers</strong></p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">Search quickly, stay informed, and act early when the right opportunity appears.</p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>No account needed to browse</strong></p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">Start exploring jobs immediately without creating an account.</p>
  </div>

  <div class="relative mt-8">
    <h5 class="mb-4 text-gray-900 dark:text-gray-50">Smarter job alerts</h5>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>Alerts designed to be useful, not overwhelming.</strong></p>
    <ul class="pb-2 mb-4 space-y-4 text-gray-500 about-list dark:text-gray-300 mt-6">
      <li class="ltr:pl-7 rtl:pr-7">Subscribe by job title, skill, technology, company, or location</li>
      <li class="ltr:pl-7 rtl:pr-7">Get alerts tailored to what you actually want to see</li>
      <li class="ltr:pl-7 rtl:pr-7">Manage or turn off subscriptions at any time</li>
      <li class="ltr:pl-7 rtl:pr-7">Spend less time searching and more time applying</li>
    </ul>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">Our goal is simple: help you find relevant roles faster, including specialist and niche opportunities that are easy to miss elsewhere.</p>
  </div>

  <div class="relative mt-8">
    <h5 class="mb-4 text-gray-900 dark:text-gray-50">Take control of your next move</h5>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300">Get notified when the latest AI, Web3, and blockchain jobs go live, and stay one step ahead in a competitive market.</p>
    <p class="mb-4 text-gray-500 about-list dark:text-gray-300"><strong>Join the alerts list today and never miss a relevant opportunity.</strong></p>
    <div class="mt-6">
            <EmailSubscriptionForm 
                v-if="!jobListingsLoading"
                class="mt-6"
                :handleResetForm="this.resetEmailForm"
                :attendanceRequirement=this.search.workingStyle
                :companyName=null
                :tags=this.search.tags
                :location=null
                :contractType=this.search.contractType
                :minSalary=null
                >
            </EmailSubscriptionForm>
    </div>
  </div>
</div>


  
      </div>
    </section>
  </div>
  </template>
  
  <script>

import EmailSubscriptionForm from "@/components/Forms/EmailSubscriptionForm.vue";
import SeoMeta from "@/components/Seo/SeoMeta.vue";

  export default{
  name: "GetNotifiedView",
  components : {
    EmailSubscriptionForm, SeoMeta
  }, 
    data() {
      return {
        search: { 
          workingStyle: 'Remote',
          tags: [],
          contractType: null,
        },
      };
    },
    mounted() {
      document.title = 'Get Notified - TheJobTap.com'
    }
  };

  </script>

